import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { APPLICATION_TYPE } from '@core';

export interface UnsavedDataDialogProps {
  description: string;
  title: string;
}

export enum UnsavedDataDialogResponse {
  SAVE = 'save',
  DISCARD = 'discard',
  CANCEL = 'cancel',
}

@Component({
  imports: [MatDialogModule],
  selector: 'avs-li-unsaved-data-dialog',
  templateUrl: './unsaved-data-dialog.component.html',
})
export class UnsavedDataDialogComponent {
  protected dialogRef = inject(MatDialogRef<UnsavedDataDialogComponent>);
  protected data = inject<UnsavedDataDialogProps>(MAT_DIALOG_DATA);
  protected readonly eUnsavedDataDialogResponse = UnsavedDataDialogResponse;
  protected isMobile = signal(false);

  private appType = inject(APPLICATION_TYPE);

  constructor() {
    this.isMobile.set(this.appType === 'mobile');
  }
}

export function openUnsavedDataDialog(dialog: MatDialog, data: UnsavedDataDialogProps) {
  const config = new MatDialogConfig();

  config.disableClose = true;
  config.backdropClass = 'backdrop-modal-panel';
  config.data = {
    ...data,
  };
  const dialogRef = dialog.open(UnsavedDataDialogComponent, config);

  return dialogRef.afterClosed();
}
